<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:45
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-24 13:21:02
-->
<template>
  <div class="login-view">
    <!-- 图标 -->
    <div style="padding: 30px;display: flex;align-items: center">
      <div style="margin-left: 20px;">
        <img src="/img/logo.png" alt="" style="width:48px;height: 48px;">
      </div>
      <div style="font-size: 20px;margin-left: 5px;font-weight: 600;">凯脉商城客服系统</div>
    </div>
    <!-- 登录 -->
    <div class="login-content">
      <el-form class="login-form" :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="60px" @keyup.enter.native="submitForm('loginForm')">
        <div class="login-brand">登录</div>
        <el-form-item label="终端" prop="userName" v-show="false">
          <el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input type="userName" v-model="loginForm.userName" autocomplete="off" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" autocomplete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          <el-button @click="resetForm('loginForm')">清空</el-button>
          <!-- <el-button @click="routerToRegister('loginForm')">注册</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="footer-box">
      <div class="copyright-box">
        <div>© Copyright2004-2025 浙江信测通信股份有限公司 版权所有</div>
        <div>
          <img src="~@/assets/image/gongan.png" class="img" />
          <a href="https://beian.miit.gov.cn" class="taga" target="_blank">浙ICP备19016515号</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "login",
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'));
      }
      callback();
    };
    var checkPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      callback();

    };
    return {
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        userName: '',
        password: ''
      },
      rules: {
        userName: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    routerToRegister() {
      this.$router.push("/register");
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/login",
            method: 'post',
            data: this.loginForm
          })
            .then((data) => {
              // 保存密码到cookie(不安全)
              // this.setCookie('username', this.loginForm.userName);
              // this.setCookie('password', this.loginForm.password);
              // 保存token
              sessionStorage.setItem("accessToken", data.accessToken);
              sessionStorage.setItem("accessId", data.id);
              sessionStorage.setItem("refreshToken", data.refreshToken);
              sessionStorage.setItem("accessTokenKm", data.accessTokenKm);
              sessionStorage.setItem("refreshTokenKm", data.refreshTokenKm);
              this.$message.success("登录成功");
              if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect)
              } else {
                this.$router.push("/home/chat");
              }
            })

        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取cookie、
    getCookie(name) {
      let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      let arr = document.cookie.match(reg)
      if (arr) {
        return unescape(arr[2]);
      }
      return '';
    },
    // 设置cookie,增加到vue实例方便全局调用
    setCookie(name, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate
        .toGMTString());
    },
    // 删除cookie
    delCookie(name) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.getCookie(name);
      if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
      }
    }
  },
  mounted() {
    // this.loginForm.userName = this.getCookie("username");
    // cookie存密码并不安全，暂时是为了方便
    // this.loginForm.password = this.getCookie("password");
  }
}
</script>

<style scoped lang="scss">
.login-view {
  width: 100%;
  height: 100%;
  background: #e8f2ff;
  background-size: cover;
  box-sizing: border-box;

  .login-content {
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    padding: 10%;

    .login-form {
      height: 340px;
      width: 400px;
      padding: 10px 30px;
      background: white;
      opacity: 0.9;
      box-shadow: 0px 0px 1px #ccc;
      border-radius: 3%;
      overflow: hidden;
      border: 1px solid #ccc;

      .login-brand {
        line-height: 50px;
        margin: 30px 0 40px 0;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 2px;
        text-transform: uppercase;
        text-align: center;
      }

      .register {
        display: flex;
        flex-direction: row-reverse;
        line-height: 40px;
        text-align: left;
        padding-left: 20px;
      }
    }
  }
}

.footer-box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  .copyright-box {
    max-width: 666px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto 10px;
    font-size: 14px;
    .img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }
    .taga {
      text-decoration: none;
      color: inherit;
    }
  }
}
</style>